import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, model } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  BaseComponent,
  GridService,
  ignoreModalError,
  ModalService,
  NotificationService,
  TabGridComponent,
} from '../../../../tms-shared';
import { UserPrinter } from '../../models';
import { UserPrinterService } from '../../services';
import { UserPrintersCreateModalComponent } from '../user-printers-create-modal/user-printers-create-modal.component';
import { UserPrintersEditModalComponent } from '../user-printers-edit-modal/user-printers-edit-modal.component';

@Component({
  selector: 'app-user-printers',
  templateUrl: './user-printers.component.html',
  styleUrl: './user-printers.component.scss',
  imports: [TabGridComponent, AsyncPipe],
})
export class UserPrintersComponent extends BaseComponent implements OnInit {
  protected readonly userPrinterService = inject(UserPrinterService);
  private readonly gridService = inject(GridService);
  private readonly modalService = inject(ModalService);
  private readonly notificationService = inject(NotificationService);
  private readonly route = inject(ActivatedRoute);

  protected model$: Observable<UserPrinter[]>;

  private userId: string;

  protected fields: FormlyFieldConfig[];

  protected columnDefs: ColDef[] = [
    this.gridService.text('printerName', $localize`Name`),
    this.gridService.text('printerAddress', $localize`Address`),
    this.gridService.text('printMethod', $localize`Print Method`),
  ];

  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('id');
    this.getModel();
  }

  getModel() {
    this.model$ = this.userPrinterService.getForUser(this.userId);
  }

  create() {
    this.openUserPrinters(undefined, undefined, this.userId, true);
  }

  edit(model: UserPrinter) {
    this.openUserPrinters(model, model.id);
  }

  delete(model: UserPrinter) {
    this.userPrinterService
      .delete(model.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.getModel(),
        error: () => this.notificationService.fail($localize`Check no documents linked to users printer`),
      });
  }

  private openUserPrinters(model: UserPrinter, id: string, userId?: string, create = false) {
    const { modal, component } = create
      ? this.modalService.openMedium<UserPrintersCreateModalComponent>(UserPrintersCreateModalComponent)
      : this.modalService.openMedium<UserPrintersEditModalComponent>(UserPrintersEditModalComponent);
    component.model.set(model);
    component.id.set(id);
    component.userId.set(userId);
    modal.result.then(() => this.getModel(), ignoreModalError);
  }
}
